import $ from 'jquery';

export default function initialise(options={}) {
    const $elements = $(options.elements);
    $elements.each((i, elem) => {
        const $element = $(elem);
        const url = $element.attr('data-visual-brief-path');
        const $designElements = $('[data-design]', $element);
        const $visualBriefButton = $('[data-visual-brief-teaser-button]', $element);

        $designElements.on('click', updateSelectedDesigns);
        $visualBriefButton.on('click', {url: url, element: elem}, visualBriefRedirect)
    });
}

function updateSelectedDesigns(event) {
    event.preventDefault();
    const $target = $(event.delegateTarget);
    const currentSelectedState = $target.attr('data-selected');

    if (currentSelectedState) {
        $target.removeAttr('data-selected');
    } else {
        $target.attr('data-selected', true);
    }
}

function visualBriefRedirect(event) {
    event.preventDefault();

    let url = event.data.url;
    let queryString = '?designs=' + selectedDesignIds(event.data.element).join(',');

    window.location = url + queryString;
}

function selectedDesignIds(element) {
    const $element = $(element);
    let selectedIds = [];

    const $selectedDesigns = $('[data-selected]', $element);
    $selectedDesigns.each((i, elem) => {
        let $design = $(elem);
        if ($design.attr('data-selected')) {
            const designId = $design.attr('data-design')
            selectedIds.push(designId);
        }
    });

    return selectedIds;
}



// WEBPACK FOOTER //
// ./js/marketing/components/visual-brief-teaser.jsx